export const fieldNames: ['firstName', 'lastName', 'organization', 'department', 'phoneNumber'] = [
	'firstName',
	'lastName',
	'organization',
	'department',
	'phoneNumber',
];
